import { getDefaultConfig } from '.';
import type { LayerConfig } from '@/views/map/layers/types';
import { LayerType } from '@/views/map/layers/types';
import { MVTLayer } from '@deck.gl/geo-layers';

const POLE_ID = 'poleID';

export const getPoleLayer = (
  _datasetId: string,
  config: LayerConfig,
  user: string = '',
  minZoom = 15,
  maxZoom = 15
) => {
  const id = LayerType[LayerType.poles];
  return new MVTLayer({
    ...getDefaultConfig(id, user),
    id,
    uniqueIdProperty: POLE_ID,
    highlightedFeatureId: POLE_ID,
    ...config,
    minZoom,
    maxZoom,
    pickable: true,
    getPointRadius: 3,
    pointRadiusMaxPixels: 8,
    getLineWidth: 1,
    opacity: 0.3,
    getFillColor: [255, 255, 255],
    getLineColor: [144, 144, 144, 205],
  });
};
